import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Loader2, Plus } from 'lucide-react';
import { useAcoes5W2HFormulario } from '@/hooks/useAcoes5W2HFormulario';
import { AcoesKanban } from '../components/AcoesKanban';
import { NewAcaoDialog } from '../components/NewAcaoDialog';
import { EditAcaoDialog } from '../components/EditAcaoDialog';

interface TabAcoesProps {
  planoAcaoId: string;
  readOnly?: boolean;
}

interface Acao {
  id: string;
  what_oque: string;
  why_porque: string;
  who_quem?: string | null;
  where_onde?: string | null;
  when_quando_inicio?: string | null;
  when_quando_fim?: string | null;
  how_como?: string | null;
  how_much_quanto?: number | null;
  status: string;
  prioridade?: string | null;
  percentual_conclusao?: number | null;
  motivo_bloqueio?: string | null;
  responsavel?: { id: string; name: string } | null;
}

export function TabAcoes({ planoAcaoId, readOnly = false }: TabAcoesProps) {
  const [isNewDialogOpen, setIsNewDialogOpen] = useState(false);
  const [editingAcao, setEditingAcao] = useState<Acao | null>(null);
  
  const {
    acoes,
    isLoading,
    createAcao,
    updateAcao,
    deleteAcao,
    updateStatus,
    isCreating,
    isUpdating,
  } = useAcoes5W2HFormulario(planoAcaoId);

  const handleStatusChange = (id: string, status: string) => {
    updateStatus({ id, status });
  };

  const handleEdit = (acao: Acao) => {
    setEditingAcao(acao);
  };

  const handleDelete = (id: string) => {
    if (confirm('Tem certeza que deseja excluir esta ação?')) {
      deleteAcao(id);
    }
  };

  const handleNewAction = () => {
    setIsNewDialogOpen(true);
  };

  const handleCreateAcao = (data: any) => {
    createAcao({
      ...data,
      formulario_plano_acao_id: planoAcaoId,
    });
    setIsNewDialogOpen(false);
  };

  const handleUpdateAcao = (data: any) => {
    if (editingAcao) {
      updateAcao({
        id: editingAcao.id,
        ...data,
      });
      setEditingAcao(null);
    }
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold">Ações 5W2H</h3>
        {!readOnly && (
          <Button onClick={handleNewAction} size="sm">
            <Plus className="h-4 w-4 mr-2" />
            Nova Ação
          </Button>
        )}
      </div>

      <AcoesKanban
        acoes={acoes}
        onStatusChange={handleStatusChange}
        onEdit={handleEdit}
        onDelete={handleDelete}
        onNew={handleNewAction}
        readOnly={readOnly}
        isLoading={isLoading}
      />

      <NewAcaoDialog
        planoAcaoId={planoAcaoId}
        open={isNewDialogOpen}
        onOpenChange={setIsNewDialogOpen}
      />

      <EditAcaoDialog
        planoAcaoId={planoAcaoId}
        open={!!editingAcao}
        onOpenChange={(open) => !open && setEditingAcao(null)}
        acao={editingAcao}
        readOnly={readOnly}
      />
    </div>
  );
}
